export const BRAND_NAME = 'Yaxle';

/**
 * Display-layer passthrough. Source copy can keep saying PartBay;
 * users see Yaxle.
 */
export function brandCopy(text: string): string {
    return text.replace(/PartBay/g, BRAND_NAME);
}
